<template>
  <!-- <div class="tab-body">
    <div class="flex justify-between items-center pt-4 pb-3 px-5 border-b border-coolGray-200">
      <div class="text-base font-semibold">Notepad</div>
      <Tooltip
        text="<i class='fa-solid fa-floppy-disk text-coolGray-100 mr-2'></i>Your notes will be saved automatically"
        styleTooltip="top-0 right-full -mt-1 mr-2 w-72"
        backgroundColor="bg-coolGray-700"
        textColor="text-xs text-gray-100"
      >
        <button><i class="fa-solid fa-circle-info"></i></button>
      </Tooltip>
    </div>
    <div class="p-5 h-full lg:h-full">
      <div class="max-height-container">
        <StudentMakeNotesTextArea />
      </div>
    </div>
  </div> -->
  <div class="h-full flex flex-col">
    <div class="flex bg-white border h-10 border-solid border-gray-200 px-4 py-2 rounded-t-lg justify-between items-center">
      <span>Notepad</span>
    </div>
    <div class="max-height-container border-solid border-gray-200 bg-white border-b border-r border-l rounded-b-lg py-3 px-3">
      <StudentMakeNotesTextArea />
    </div>
  </div>
</template>
<script>
  import Tooltip from '../../../components/Tooltip.vue';
  import StudentMakeNotesTextArea from './../components/Participants/StudentMakeNotes.vue';

  export default {
    components: {
      Tooltip,
      StudentMakeNotesTextArea,
    },
  };
</script>
<style scoped>
  .max-height-container {
    height: calc(100% - 100px);
  }
  .tab-body {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// PromptSideBarStudentNotepad.vue?0321ec3c